@use "../../../globals/settings";
@use "../../../globals/bcp";
@use "../../../globals/bcp-2022/objects/links";
@use "../../../globals/bcp-2022/objects/lists";
@use "../../../globals/libs/hy.core.css/layout/page-row";
//TT CUSTOMS START
@use "../../../globals/bcptools/tools/color-schemes";
//TT CUSTOMS END
$self: ".a-search-suggestions";

:host {
  display: block;
  position: relative;

  @include bcp.z-index("search", 1);
}

.a-search-suggestions-wrapper {
  background: bcp.colorVar("bg");
  box-shadow: settings.$box-shadow;
  position: absolute;
  left: 0;
  right: 0;
  margin-top: bcp.n(-2);
  padding-bottom: bcp.n(4);
  box-sizing: border-box;

  &::after {
    content: "";
    display: block;
    position: absolute;
    top: (settings.$box-shadow-height * -1) + 1;
    left: 0;
    right: 0;
    height: settings.$box-shadow-height;
    background: bcp.colorVar("bg");
  }

  @include bcp.respond-lte(tabletp) {
    margin-top: 10px;
  }

  // TT Custom Start
  @include bcp.theme("buderus") {
    @include bcp.set-css-var(link, active-color, settings.$white);
  }
  // TT Custom End
}

.a-search-suggestions {
  @include lists.transparent;

  &__item {
    display: block;

    &--with-separator {
      border-bottom: 1px solid bcp.colorVar("separator");
    }
  }

  &__result-link {
    @include links.inline;
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-areas:
      "name price"
      "sku . ";
    padding-top: bcp.n(1);
    padding-bottom: bcp.n(1);

    @include bcp.set-css-var(link, color, settings.$text-color);
    @include bcp.set-css-var(link, text-decoration, none);

    &:hover {
      background: bcp.colorVar("bg-secondary");
      color: bcp.cssVar(link, color);
      text-decoration: bcp.cssVar(link, text-decoration);
    }

    @include bcp.respond-gt(mobile) {
      grid-template-columns: 75% 25%;
      grid-template-areas:
        "name price"
        "sku . ";
      padding: bcp.n(1);
    }
  }

  &__item-name {
    @include bcp.text-overflow(2);
    grid-area: name;
    display: -webkit-box;
    overflow-wrap: anywhere; // TT Custom

    &--family {
      font-weight: bcp.$font-weight-bold;
    }
  }

  &__item-sku {
    @include bcp.text-s;
    grid-area: sku;
  }

  &__item-price {
    grid-area: price;
    justify-self: right;
    font-weight: bcp.$font-weight-bold;
  }

  &__results-link {
    padding-top: bcp.n(4);
  }
}

.l-page-row {
  @include page-row.page-row;
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...

/* stylelint-disable no-duplicate-selectors  -- customs */
/* stylelint-disable no-descending-specificity -- customs */

.a-search-suggestions {
  &__item {
    display: flex;
    padding-top: bcp.n(2);

    @include bcp.respond(mobile) {
      tt-add-to-cart-mini {
        display: none;
      }
    }

    &-name {
      font-weight: bold;
    }

    &-sku-label {
      font-size: bcp.n(1.5);
    }

    &-sku--value,
    &-ean--value {
      padding-left: bcp.n(0.5);
    }

    &-price-label {
      display: block;
      width: 100%;
      font-size: bcp.n(1.5);
    }

    &-wrapper {
      &-sku {
        grid-area: sku;
      }

      &-price {
        grid-area: price;

        @include bcp.respond(mobile) {
          text-align: end;
        }
      }
    }
  }

  &__result-link {
    flex-grow: 1;
    grid-template-areas: "sku price";
    padding-top: 0;
  }

  &--categories {
    border-top: 1px solid bcp.colorVar("separator");
    padding-bottom: bcp.n(4);

    .a-search-suggestions__item {
      padding: bcp.n(2) 0;

      .a-search-suggestions__result-link {
        padding-bottom: 0;
      }
    }
  }

  &__category {
    &-name {
      font-weight: bcp.$font-weight-bold;
      padding: bcp.n(1);
    }
  }

  &-wrapper {
    padding-bottom: 0;
  }
}

.a-search-suggestions__item.a-search-suggestions__results-link {
  padding-top: bcp.n(4) !important;
  padding-bottom: bcp.n(4) !important;
}

@include bcp.theme("ivt") {
  .a-search-suggestions-wrapper {
    @include color-schemes.generate("light-primary");
    @include bcp.set-css-var(link-active, color, settings.$brand-main72);
    @include bcp.set-css-var(link-hover, color, settings.$brand-main70);
    @include bcp.set-css-var(
      button-secondary-hover,
      background-color,
      settings.$brand-main71
    );
    @include bcp.set-css-var(
      button-secondary-hover,
      border-color,
      settings.$brand-main70
    );
    @include bcp.set-css-var(
      button-secondary-hover,
      color,
      settings.$brand-main70
    );
    @include bcp.set-css-var(
      button-secondary-active,
      background-color,
      settings.$brand-main73
    );
    @include bcp.set-css-var(
      button-secondary-active,
      border-color,
      settings.$brand-main72
    );
    @include bcp.set-css-var(
      button-secondary-active,
      color,
      settings.$brand-main72
    );
  }
}

@include bcp.theme("buderus") {
  .a-search-suggestions-wrapper {
    margin-top: bcp.n(1);

    @include color-schemes.generate("dark-primary");

    f-link {
      @include bcp.set-css-var(
        link,
        color,
        bcp.colorVar("button-primary-hover-bg")
      );
      @include bcp.set-css-var(link-hover, color, settings.$brand-main70);
    }
  }
}
